module.exports = __webpack_public_path__ + "static/CircularPro-Bold.0baac4db.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Bold.woff
// module id = 719
// module chunks = 168707334958949